import React, { useState } from 'react';
import { Folder, FileText, FolderOpen, ChevronRight, ChevronDown } from 'lucide-react';

function FileTreeNode({ name, path, files, selectedFile, onSelect, depth }) {
  const [expanded, setExpanded] = useState(depth < 2);
  const children = {};
  const directFiles = [];

  Object.keys(files).forEach(function(filePath) {
    if (filePath.startsWith(path + '/')) {
      var rest = filePath.slice(path.length + 1);
      var parts = rest.split('/');
      if (parts.length === 1) {
        directFiles.push({ name: parts[0], path: filePath });
      } else {
        var dirName = parts[0];
        if (!children[dirName]) children[dirName] = {};
        children[dirName][filePath] = files[filePath];
      }
    }
  });

  var isDir = Object.keys(children).length > 0 || directFiles.length > 0;

  if (!isDir && path) {
    var isSelected = selectedFile === path;
    var ext = name.split('.').pop();
    var iconColor = ext === 'tsx' || ext === 'ts' ? 'text-blue-400' :
                    ext === 'jsx' || ext === 'js' ? 'text-yellow-400' :
                    ext === 'css' ? 'text-pink-400' :
                    ext === 'json' ? 'text-green-400' :
                    ext === 'html' ? 'text-orange-400' : 'text-zinc-400';
    return (
      <button
        onClick={function() { onSelect(path); }}
        className={'flex items-center gap-1.5 w-full px-2 py-1 text-xs rounded hover:bg-white/5 transition-colors ' + (isSelected ? 'bg-emerald-500/10 text-emerald-400' : 'text-zinc-300')}
        style={{ paddingLeft: (depth * 12 + 8) + 'px' }}
        data-testid={('file-tree-file-' + path).replace(/[^a-zA-Z0-9-]/g, '-')}
      >
        <FileText className={'w-3.5 h-3.5 shrink-0 ' + iconColor} />
        <span className="truncate">{name}</span>
      </button>
    );
  }

  return (
    <div>
      {path && (
        <button
          onClick={function() { setExpanded(!expanded); }}
          className="flex items-center gap-1.5 w-full px-2 py-1 text-xs text-zinc-300 hover:bg-white/5 rounded transition-colors"
          style={{ paddingLeft: (depth * 12 + 8) + 'px' }}
          data-testid={('file-tree-folder-' + path).replace(/[^a-zA-Z0-9-]/g, '-')}
        >
          {expanded ? <ChevronDown className="w-3 h-3 shrink-0" /> : <ChevronRight className="w-3 h-3 shrink-0" />}
          {expanded ? <FolderOpen className="w-3.5 h-3.5 shrink-0 text-amber-400" /> : <Folder className="w-3.5 h-3.5 shrink-0 text-amber-400" />}
          <span className="truncate">{name}</span>
        </button>
      )}
      {(expanded || !path) && (
        <React.Fragment>
          {Object.keys(children).sort().map(function(dirName) {
            return (
              <FileTreeNode
                key={dirName}
                name={dirName}
                path={path ? path + '/' + dirName : dirName}
                files={files}
                selectedFile={selectedFile}
                onSelect={onSelect}
                depth={depth + 1}
              />
            );
          })}
          {directFiles.sort(function(a, b) { return a.name.localeCompare(b.name); }).map(function(f) {
            return (
              <FileTreeNode
                key={f.path}
                name={f.name}
                path={f.path}
                files={{}}
                selectedFile={selectedFile}
                onSelect={onSelect}
                depth={depth + 1}
              />
            );
          })}
        </React.Fragment>
      )}
    </div>
  );
}

export default function FileTree({ files, selectedFile, onSelect }) {
  var rootDirs = {};
  var rootFiles = [];

  Object.keys(files).forEach(function(path) {
    var parts = path.split('/');
    if (parts.length === 1) {
      rootFiles.push({ name: parts[0], path: path });
    } else {
      var dir = parts[0];
      if (!rootDirs[dir]) rootDirs[dir] = {};
      rootDirs[dir][path] = files[path];
    }
  });

  return (
    <div className="py-1 overflow-y-auto h-full">
      {Object.keys(rootDirs).sort().map(function(dirName) {
        return (
          <FileTreeNode
            key={dirName}
            name={dirName}
            path={dirName}
            files={files}
            selectedFile={selectedFile}
            onSelect={onSelect}
            depth={0}
          />
        );
      })}
      {rootFiles.sort(function(a, b) { return a.name.localeCompare(b.name); }).map(function(f) {
        return (
          <FileTreeNode
            key={f.path}
            name={f.name}
            path={f.path}
            files={{}}
            selectedFile={selectedFile}
            onSelect={onSelect}
            depth={0}
          />
        );
      })}
    </div>
  );
}
